export const inviteUser = payload => ({
  type: 'INVITE_USER',
  payload,
  loader: true,
});
export const usersList = (userType, payload) => ({
  type: 'GET_USER_LIST',
  payload,
  userType,
});
export const setUsersList = data => ({
  type: 'ALL_USER_LIST',
  data,
});
export const getControlUserDetails = userId => ({
  type: 'GET_CONTROLLED_USER_DETAILS',
  userId,
});

export const userDetailsReceived = data => ({
  type: 'CONTROLLED_USER_DETAILS_RECEIVED',
  data,
});

export const assignCard = payload => ({
  type: 'ASSIGN_CARD',
  payload,
  loader: true,
});
export const userInviteStatus = data => ({
  type: 'USER_INVITE_STATUS',
  data,
});
export const resetUserInviteStatus = () => ({
  type: 'RESET_INVITE_STATUS',
});
export const getAllMerchantData = payload => ({
  type: 'GET_MERCHANT',
  payload,
});

export const setMerchantData = data => ({
  type: 'SET_MERCHANT',
  data,
});

export const updateMerchantData = payload => ({
  type: 'UPADETE_CARD_MERCHANT',
  payload,
  loader: true,
});

export const emptyUserList = () => ({
  type: 'EMPTY_USER_LIST',
});

export const resendInvite = payload => ({
  type: 'RESEND_INVITE',
  payload,
  loader: true,
});

export const storeInviteList = data => ({
  type: 'STORE_INVITE_LIST',
  data,
});

export const updateUserLimit = (payload, userId, cb) => ({
  type: 'UPDATE_USER_LIMIT',
  payload,
  userId,
  cb,
  loader: true,
});

export const saveLimitUpdateData = data => ({
  type: 'LIMIT_UPDATE_RES',
  data,
});

export const showSnackbar = data => ({
  type: 'SHOW_SNACK_BAR',
  data,
});

export const getControlUsers = payload => ({
  type: 'CONTROLLED_USER',
  payload,
});

export const setControlUsers = data => ({
  type: 'SET_CONTROLLED_USER',
  data,
});

export const onboardDataUpdate = data => ({
  type: 'ONBOARD_USER_ADD',
  data,
});
